"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledH1 = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledH1 = styled_components_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\ttext-transform: uppercase;\n\tborder-bottom: 0;\n\tmargin: 0 0 20px;\n\tmargin-bottom: 5px !important;\n\tpadding-bottom: 0px !important;\n\tfont-weight: 900;\n\tfont-size: 38px;\n\tfont-family: arial;\n"], ["\n\ttext-transform: uppercase;\n\tborder-bottom: 0;\n\tmargin: 0 0 20px;\n\tmargin-bottom: 5px !important;\n\tpadding-bottom: 0px !important;\n\tfont-weight: 900;\n\tfont-size: 38px;\n\tfont-family: arial;\n"])));
var templateObject_1;
